<div class="row">
  <div class="col-xs-12 col-12">
    <pagination [totalItems]="155" [rotate]="rotate" [maxSize]="maxSize"></pagination>
  </div>
</div>

<button type="button" class="btn btn-info" [style.background-color]="rotate ? 'blue' : 'red'" (click)="toggleBtn()">Current page link center is {{status}}</button>
